import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "enlargement-modal" }
const _hoisted_2 = { class: "enlargement-modal__image" }

import {
  computed,
} from 'vue';
import {
  useStore,
} from 'vuex';
import ClickWrapper from '@/components/ClickWrapper.vue';
import ResponsiveImage from '@/components/ResponsiveImage.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'Enlargement',
  setup(__props) {

library.add(faTimes);

const store = useStore();

const componentProps = computed(() => store.getters['enlargement/props']);

const close = () => {
  store.dispatch('enlargement/clear');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "enlargement-modal__close",
      onClick: close
    }, [
      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-times" })
    ]),
    _createVNode(ClickWrapper, {
      class: "enlargement-modal__container",
      ref: "root"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ResponsiveImage, _normalizeProps(_guardReactiveProps(componentProps.value)), null, 16)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})